import React from "react";
import Header from "./header";
import Banner from "./Banner";
import Partners from "./Partners";
import CardsItems from "./CardsItems";
import Interviews from "./Interviews";
import EmailManager from "./EmailManager";
import HelpBox from "./HelpBox";
import Market from "./Market";
import Community from "./Community";
import Foot from "./Foot";
// import LivekitAgentComponent from "./LivekitAgentComponent";
// Import the LiveKitAgentPlayground component
import LiveKitAgentPlayground from "./LivekitAgentPlayground/LivekitAgentPlayground";

function App() {
  return (
    <div className="home">
      <Header />
      <Banner />
      <div className="py-8 bg-gradient-to-b from-red-50 to-yellow-20">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Experience Our AI Assistant
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Powered by LiveKit's real-time audio and video technology, our AI
              assistant provides a seamless communication experience.
            </p>
          </div>
          <LiveKitAgentPlayground />
          <div className=" text-center   text-gray-600 text-base">
            <p>Ask questions like "What services do you offer?"</p>
          </div>
        </div>
      </div>
      <Partners />
      <CardsItems />
      <Interviews />

      <EmailManager />
      <HelpBox />
      <Market />
      <Community />
      <Foot />
    </div>
  );
}

export default App;
